import Phaser from 'phaser';
import { CHAPTER_TITLE, GAME_H, GAME_W } from '@/core/config';
import { ctxOf } from '@/core/context';
import { SceneKeys } from '@/core/scenes/keys';
import { renderChapterEndIfAvailable } from '@/core/wiring';
import { audio } from '@/audio';

/** Chapter-end card shell: save / back to title / restart. UI builder restyles it. */
export class ChapterEndScene extends Phaser.Scene {
  constructor() { super(SceneKeys.CHAPTER_END); }
  create(): void {
    const ctx = ctxOf(this);
    this.cameras.main.setBackgroundColor('#05070a');
    try { audio().playMusic(null, 1500); audio().setAmbience([], 1500); } catch { /* audio optional */ }
    if (renderChapterEndIfAvailable(this, { onSave: () => ctx.saveManual(), onTitle: () => void ctx.toTitle(), onRestart: () => void ctx.newGame() })) return;
    this.add.text(GAME_W / 2, 110, `第一章 · ${CHAPTER_TITLE}`, { fontFamily: 'serif', fontSize: '24px', color: '#e2c48c' }).setOrigin(0.5);
    this.add.text(GAME_W / 2, 145, '—— 完 ——', { fontFamily: 'serif', fontSize: '14px', color: '#8a8f99' }).setOrigin(0.5);
    const opts: { label: string; run: () => void }[] = [
      { label: '保存进度', run: () => { ctx.saveManual(); status.setText('已保存'); } },
      { label: '回到标题', run: () => void ctx.toTitle() },
      { label: '重新开始', run: () => void ctx.newGame() },
    ];
    const status = this.add.text(GAME_W / 2, GAME_H - 30, '', { fontFamily: 'sans-serif', fontSize: '12px', color: '#c9b89a' }).setOrigin(0.5);
    opts.forEach((o, i) => {
      this.add.text(GAME_W / 2, 210 + i * 26, o.label, { fontFamily: 'sans-serif', fontSize: '16px', color: '#ffffff' }).setOrigin(0.5).setInteractive({ useHandCursor: true }).on('pointerdown', o.run);
    });
    const kb = this.input.keyboard;
    kb?.on('keydown-ENTER', () => opts[1]?.run());
    this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => kb?.removeAllListeners());
  }
}
